module.exports = __webpack_public_path__ + "img/1491627405.7c28fd32.jpg";